// extracted by mini-css-extract-plugin
export var container = "DevTools-module--container--o8ZZ-";
export var devToolImg = "DevTools-module--devToolImg--2m-BE";
export var devTool = "DevTools-module--devTool--2fony";
export var demo = "DevTools-module--demo--1BTJK";